import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { ratioChartColors } from "../../clients-dashboard-style";
import { CustomizedChartRatio } from "./hirings-chart-styles";
import { getHiringsChartData } from "./helpers";
import { TicksProps } from "../../clients-dashboard-types";
import { IGetHiringsData } from "../../../../../services/ClientsDashboardServices.dto";

const HiringsChartRatio = ({ data }: { data: IGetHiringsData }) => {
  const [hiddenSeries, setHiddenSeries] = React.useState<Array<string>>([]);

  const newData = getHiringsChartData(data, true);
  const productTypes = Object.keys(newData[0]);

  const handleLegendClick = (dataKey: string) => {
    // Desactiva y activa las barras de los productos seleccionados
    const businessLine = dataKey.split(" ")[1];
    if (hiddenSeries.includes(businessLine)) {
      setHiddenSeries(hiddenSeries.filter((el) => !el.includes(businessLine)));
    } else {
      setHiddenSeries((prev) => [...prev, businessLine]);
    }
  };

  const renderCustomTick = (tickProps: TicksProps) => {
    const { x, y, index } = tickProps;
    // Se busca la primera aparición de un año para mostrarlo una sóla vez
    const isYearChange = index === 0 || newData[index].year !== newData[index - 1].year;

    return (
      <g transform={`translate(${x},${y})`}>
        {isYearChange && (
          <text x={0} y={0} dy={40} textAnchor="middle" fill="#666" fontSize={20}>
            {newData[index].year}
          </text>
        )}
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {newData[index].month}
        </text>
      </g>
    );
  };

  return (
    <CustomizedChartRatio items={productTypes.length}>
      <ResponsiveContainer width="100%" height={800}>
        <BarChart
          width={500}
          height={300}
          data={newData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="month" height={70} tick={renderCustomTick} />
          <XAxis dataKey="year" xAxisId={1} hide />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend
            iconType="circle"
            align="left"
            onClick={(props) => handleLegendClick(props.dataKey)}
          />
          {productTypes.map((type: string, index) => {
            if (type === "month" || type === "year") return null;
            const businessLine = type.split(" ")[1];
            return (
              <Bar
                key={type}
                dataKey={type}
                fill={ratioChartColors[index]}
                hide={hiddenSeries.includes(businessLine)}
                xAxisId={index % 2 ? 1 : 0}
              />
            );
          })}
        </BarChart>
      </ResponsiveContainer>
    </CustomizedChartRatio>
  );
};

export default HiringsChartRatio;
